<template>
  <div>
    <el-card style="margin-bottom:20px;height: 500px;">
      <div slot="header" class="clearfix"><span>关于我</span></div>
      <div class="user-profile">
        <div class="box-center"><pan-thumb :image="user.avatar" :height="'100px'" :width="'100px'" :hoverable="false"></pan-thumb></div>
        <div class="box-center">
          <div class="user-name text-center">{{ user.name }}</div>
          <div class="user-role text-center text-muted">{{user.deptName}}·{{user.jobName}}</div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import PanThumb from '@/components/PanThumb';

export default {
  components: { PanThumb },
  props: {
    user: {
      type: Object,
      default: () => {
        return {
          name: '',
          email: '',
          avatar: '',
          roles: []
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.box-center {
  margin: 0 auto;
  display: table;
}

.text-muted {
  color: #777;
}

.user-profile {
  // position: relative;
  // &:after {
  //   position: absolute;
  //   content: ' ';
  //   height: 1px;
  //   top: 185px;
  //   left: 0;
  //   right: 0;
  //   bottom: 0;
  //   background: royalblue;
  // }
  .user-name {
    font-weight: bold;
  }

  .box-center {
    padding-top: 10px;
  }

  .user-role {
    padding-top: 10px;
    font-weight: 400;
    font-size: 14px;
  }

  .box-social {
    padding-top: 30px;

    .el-table {
      border-top: 1px solid #dfe6ec;
    }
  }

  .user-follow {
    padding-top: 20px;
  }
}

.user-bio {
  margin-top: 20px;
  color: #606266;

  span {
    padding-left: 4px;
  }

  .user-bio-section {
    font-size: 14px;
    padding: 15px 0;

    .user-bio-section-header {
      border-bottom: 1px solid #dfe6ec;
      padding-bottom: 10px;
      margin-bottom: 10px;
      font-weight: bold;
    }
  }
}
</style>
